// components
import nav from "./components/nav";
import media from "./components/media";
import slider from "./components/slider";
import shops from "./components/shops";
import tint from "./components/tint";
import services from "./components/services";
import accordion from "./components/accordion";
import popin from "./components/popin";
import blocImages from "./components/blocImages";
import popinInfos from "./components/popinInfos";

// animations
import aos from "./anims/appear-on-scroll";
import quickAccess from "./anims/quick-access";
import inscription from './components/inscription';
import deals from "./components/deals";

const main = {
    init: function () {
        nav.init();             // Nav on mobile + set sticky on scroll
        media.init();           // home media : slider + img mobile + API horaires d'ouvertures
        services.init();        // bloc de redirection en bas : btn loadmore sur mobile
        tint.init();            // api tint pour les réseaux sociaux
        accordion.init();       // accordéon sur la page Agenda
        inscription.init();     // formulaire d'inscription NL
        deals.init();           // tronquer la longueur des offres sur les pages marques
        popin.init();           // popin recrutement : liste avec logos des centres
        popinInfos.init();      // popin infos : apparition après 15sec sur le site
        shops.init();           // filtres du bloc boutiques (home + tpl boutiques) : autocomplétion, filtres par lettre ou par catégorie / sous-catégorie

        blocImages.init();      // carousel sur mobile

        main.onLoad();          // when DOM is loaded
        main.onScroll();        // check le scroll de la page
        main.onResize();        // check les resize de page

    },
    onLoad: function () {
        // lorsque la page est entièrement chargée
        window.addEventListener('load', function () {
            slider.init();      // initialisation des sliders
            quickAccess.init(); // barre sticky sur la droite
            aos.init();         // apparition des blocs au scroll
        });
    },
    onScroll: function () {
        // lorsque la page est entièrement chargée
        window.addEventListener('scroll', function (event) {
            // lister ici fonctions qui ont besoin d'être (re)chargées au scroll
            nav.setSticky();    // passage de la barre de navigation en fixed au scroll
            quickAccess.setSticky();  // barre sticky
        });
    },
    onResize: function () {
        let originalResize = evt => {
            // lister ici fonctions qui ont besoin d'être (re)chargées au resize
            media.RWD();        // changement des visuels entre mobile et desktop
            slider.tabsWidth(); // blocs onglet du template à modules "page"
            shops.catsWidth();  // largeur du bloc filtres catégories tpl boutiques : pour créer un scroll horizontal
        };

        let resizeTaskId = null;
        // lorsque l'internaute modifie la taille de sa fenêtre
        window.addEventListener('resize', evt => {
            if (resizeTaskId !== null) {
                clearTimeout(resizeTaskId);
            }

            resizeTaskId = setTimeout(() => {
                resizeTaskId = null;
                originalResize(evt);
            }, 100);
        });
    }
}

export default main;


// WEBPACK FOOTER //
// ./src/scripts/main.js